module.exports = __webpack_public_path__ + "img/dorota-czerwinska.9cf6fdce.png";